import isVisible from "../utils/is-visible";

import ButtonBox from "./button-box";

const selectorSearch = ".js-search";
const selectorSearchButtons = ".js-search__button";

export default class SearchBar extends ButtonBox {
  constructor($search, $buttons) {
    super($search, $buttons);

    this.$field = $search.querySelector(".search-field");
    console.log("search init");
  }

  init() {
    super.init();

    this.initFocusin();
  }

  initFocusin() {
    document.addEventListener(
      "focusin",
      (e) => {
        console.log(document.activeElement);
        if (this.$field === document.activeElement) {
          if (e.sourceCapabilities) {
            if (!this.isOpen) {
              this.updateCurrentButton(this.getVisibleButton());
              this.updateSizes();
              this.updateStyles();
              this.open();
            }
          }
        }
      },
      true
    );
  }

  open() {
    super.open();
    this.$field.focus();
    document.body.classList.add("search-menu-open");
  }

  close() {
    super.close();
    document.body.classList.remove("search-menu-open");
  }

  getVisibleButton() {
    return [...this.$buttons].filter(($button) => isVisible($button))[0];
  }

  static bindDOM($container = document.body) {
    const instances = [];
    $container.querySelectorAll(selectorSearch).forEach(($search) => {
      const $buttons = $container.querySelectorAll(selectorSearchButtons);
      instances.push(new SearchBar($search, $buttons));
    });
    return instances;
  }
}
